import React, { useState } from 'react';
import './courseDetailCardMobile.css'
import C2wCourseDetailsTopicCard from './courseDetailsTopicCard';


  function C2wCourseDetailCardMobile( {obj,  topicIndex, isSelectedIndex, handleIsIndexFlag, type }) {
    // const isSelected = isSelectedIndex === topicIndex;
    const [flag, setFlag] = useState(false)

    /**
 * @constant onClick
 * @auther Vishal Lohbande
 * @description Handles the toggle logic when a topic card is clicked.
 * It checks if the current topic (`topicIndex`) is already selected 
 * by comparing it with `isSelectedIndex`.
 * 
 * If the topic is already selected (`isSelected` is true), it deselects it 
 * by setting the selected index to -1. Otherwise, it updates the selected 
 * index to the current `topicIndex`.
 * 
 * This logic supports UI behaviors like expanding/collapsing topic details 
 * on selection/deselection.
 * 
 * @function
 * @returns {void}
 * 
 * Usage:
 * Called when a user clicks on a topic card to toggle its selection state.
 */
    const onClick = (topicIndex) => {
      if (flag) {
        handleIsIndexFlag(-1); 
        setFlag(false)
      } else {
        handleIsIndexFlag(topicIndex);
        setFlag(true)
      }
    };  
    
    return (
    <div className='C2wCourseDetailCardMobile_ctn' onClick={ () => onClick(topicIndex)}>
      <div className='C2wCourseDetailCardMobile_tag' style={{width: type=== 'Online' ? null : '100%'}}>
        <div>
          <div className='C2wCourseDetailCardMobile_head'>{`Topic ${topicIndex + 1}`}</div>
          <div className='C2wCourseDetailCardMobile_title'>{obj?.Title}</div>
        </div>
 
        {isSelectedIndex && flag ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 15L12 9L18 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        ) : (
          
          <svg onClick={() => onClick(topicIndex)} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M6 9L12 15L18 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>)
        } 
      </div> 
      { isSelectedIndex && flag ? (
      <div className='C2wCourseDetailCardMobile_content_ctn'>
        { type === 'Online' ? (
        <div className='C2wCourseDetailCardMobile_content_count'>
          <div className='C2wMobilehighLighCount'>{'All'}<span>{obj?.contentCount?.allCount}</span></div>
          <div className='C2wMobilehighLighCount'>{'Lectures'}<span>{obj?.contentCount?.lectureCount}</span></div>
          <div className='C2wMobilehighLighCount'>{'Assignments'}<span>{obj?.contentCount?.assignmentCount}</span></div>
          <div className='C2wMobilehighLighCount'>{'Quiz'}<span>{obj?.contentCount?.quizCount}</span></div>
        </div>
        ) : null
        }
         { obj?.subTopicArray?.map((obj, i) => (
            <C2wCourseDetailsTopicCard obj={obj} i={i} type={type}/>
          ))}

      </div>) : null
      }

    </div>
  )
}

export default C2wCourseDetailCardMobile
